import { Button, Col, Row } from "reactstrap";
import { AboutApplicationDescription, ChatzyForEnterprise, Href, TeamWorkText, TeamWorkTitle } from "../../Constants/Constants";
import { dynamicImage, Image } from "../../Utils";

const TeamWork = () => {
  return (
    <section className="section-py-space team-work-main" id="team">
      <div className="custom-container">
        <Row className="team-block">
          <Col md="6">
            <div className="team-work-content">
              <div>
                <div className="ply-main">
                  <div className="ply-content">
                    <div className="ply-sub-content">
                      <i className="fa fa-play" />
                    </div>
                  </div>
                  <h3>{TeamWorkTitle}</h3>
                </div>
                <h2>{TeamWorkText}</h2>
                <h4>{AboutApplicationDescription}</h4>
                <Button tag={"a"} className="pricing-btn" href={Href}>
                  {ChatzyForEnterprise}
                </Button>
              </div>
            </div>
          </Col>
          <Col md="6">
            <div className="team-work-content">
              <Image className="img-fluid team-main" src={dynamicImage("index/team.png")} alt="chit-chat" />
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default TeamWork;
